(function () {
    'use strict';

    angular.module('inoApp').run(['$rootScope', '$translate', appRun]);

    function appRun($rootScope, $translate) {
        $rootScope.$on('$translatePartialLoaderStructureChanged', function () {
			$translate.refresh();
		});
    }
})();